import { Medlemskapstype } from '../api/medlemskapAPI';
import styles from './medlemskapType.module.scss';
import { ageSegments } from '../Utils';

function capitalizeFirstLetter(string: string) {
    if (string && string.length > 0) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
        return string;
    }
}

function Enkeltmedlemskap(props: { medlemskapstyper: Medlemskapstype[] }) {
    return (
        <div className={[styles.typeContainer, styles.fullWidth].join(' ')}>
            <h2 className={styles.name}>Enkeltmedlemskap</h2>
            <div className={styles.priceLine}>
                {props.medlemskapstyper.map((medlemskap, index) => (
                    <div key={medlemskap.id} className={styles.membershipLine}>
                        <div className={styles.ageSegment}>
                            {capitalizeFirstLetter(medlemskap.summaryTitle.replace('Medlemskap ', '')) +
                                ' (' +
                                ageSegments[index] +
                                '): ' +
                                medlemskap.price +
                                ' kr'}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Enkeltmedlemskap;
